module.exports = __webpack_public_path__ + "static/media/DSC09544.09ae996f.jpg";